import InviteDialog from "./Container"

export default InviteDialog
